(function () {
	"use strict";

	angular.module("swurveys.maker")
		.factory("paymentTierModal", Handler);

	function Handler(ModalService) {

		function show(currentSwurvey) {
			return ModalService.showModal({
					templateUrl: "app/modals/payments/tier/tier.html",
					controller: ['$element', 'close', function ($element, close) {

						this.currentSwurvey = currentSwurvey;

						this.close = function (tier) {
							close(tier, 500);
							$(".modal-backdrop")
								.remove();
						};
					}],
					controllerAs: "modal"
				});
		}

		return {
			show: show
		};
	}
}());
